import { jsxs as n, jsx as r } from "react/jsx-runtime";
import { SmallStoreCardContainer as s, LogoWrapper as i, SmallStoreCardText as p } from "./style.js";
import { Image as c } from "../Image/index.js";
import { useTranslation as d } from "../../hooks/useTranslation/index.js";
function x({
  children: t,
  link: a,
  logo: o,
  onClick: m,
  className: e
}) {
  const { t: l } = d("common");
  return /* @__PURE__ */ n(s, { onClick: m, url: a, className: e, children: [
    o && /* @__PURE__ */ r(i, { children: /* @__PURE__ */ r(c, { src: o, alt: l("small-store-card-alt") }) }),
    /* @__PURE__ */ r(p, { children: t })
  ] });
}
export {
  x as SmallStoreCard
};
